import React from "react";
import { WEEKDAYS } from "lib/date";

import Date from "components/Date";
import Currency from "components/Currency";
import ClubBookingStatusIndicator from "components/school_money/history/ClubBookingStatusIndicator";
import DinnerBookingStatusIndicator from "components/school_money/history/DinnerBookingStatusIndicator";

export default class HistoryItem extends React.Component {
  
  formatPaymentMethod(paymentMethod) {
    switch (paymentMethod) {
      case "cc": return "Credit Card";
      case "dc": return "Debit Card";
      case "ca": return "Cash";
      case "ba": return "Bank Transfer";
      case "vo": return "Voucher";
      case "pp": return "PayPoint";
      case "ch": return "Cheque";
      default: return "Unknown";
    }
  }
  
  getPaymentItemDetails() {
    const payment = this.props.historyItem.toJS();
    // -1 installment means this is a credit payment
    const isCredit = payment.installmentNumber === -1;
    return [
      [ "Instalment",     isCredit ? "Credit" : payment.installmentNumber ],
      [ "Paid",           <Currency amount={payment.paidAmount} /> ],
      [ "Payment Date",   <Date date={payment.paidDate} /> ],
      [ "Refunded",       <Currency amount={payment.refundedAmount} /> ],
      [ "Payment Method", this.formatPaymentMethod(payment.paymentMethod) ]
    ]
  }
  
  getDinnerItemDetails() {
    const dinner = this.props.historyItem.toJS();
    const weekdayStatus = WEEKDAYS.map((weekdayName, weekdayIndex) => [
      weekdayName,
      <DinnerBookingStatusIndicator {...dinner.booking[weekdayIndex]} />
    ]);
    return [
      [ "Dinner",       dinner.description ],
      [ "Start Date",   <Date date={dinner.startDate} /> ],
      [ "End Date",     <Date date={dinner.endDate} /> ],
      ...weekdayStatus,
      [ "Weekly Total", <Currency amount={dinner.totalPrice} /> ]
    ]
  }
  
  getClubItemDetails() {
    const club = this.props.historyItem.toJS();
    const weekdayStatus = WEEKDAYS.map((weekdayName, weekdayIndex) => [
      weekdayName,
      <ClubBookingStatusIndicator {...club.booking[weekdayIndex]} />
    ]);
    return [
      [ "Start Date",   <Date date={club.startDate} /> ],
      [ "End Date",     <Date date={club.endDate} /> ],
      ...weekdayStatus,
      [ "Weekly Total", <Currency amount={club.weeklyTotalAmount} /> ],
      [ "Amount Paid",  <Currency amount={club.paidAmount} /> ],
      [ "Amount Due",   <Currency amount={club.dueAmount} /> ]
    ]
  }
  
  getMealItemDetails() {
    const meal = this.props.historyItem.toJS();
    return meal.selections.map(({ name, price }) => {
      return [ name, <Currency amount={price} /> ];
    });
  }
  
  getDetails() {
    switch (this.props.type) {
      case "payment" : return this.getPaymentItemDetails();
      case "dinner"  : return this.getDinnerItemDetails();
      case "club"    : return this.getClubItemDetails();
      case "meal"    : return this.getMealItemDetails();
      default        : return [];
    }
  }
  
  renderPaymentHeader() {
    return (
      <div className="history-item__header-text">
        { this.props.historyItem.get("description") }
      </div>
    )
  }
  
  renderClubHeader() {
    return (
      <div className="history-item__header-text">
        { this.props.historyItem.get("description") }
      </div>
    )
  }
  
  renderMealHeader() {
    return (
      <div className="history-item__header-text">
        <Date date={this.props.historyItem.get("date")} />
      </div>
    )
  }
  
  renderHeader() {
    switch (this.props.type) {
      case "payment" : return this.renderPaymentHeader();
      case "club"    : return this.renderClubHeader();
      case "meal"    : return this.renderMealHeader();
      default        : return null;
    }
  }
  
  renderDetails() {
    return this.getDetails().map((row, index) => (
      <tr key={index}>
        <td className="history-item__detail-label">{ row[0] }</td>
        <td className="history-item__detail-value">{ row[1] }</td>
      </tr>
    ));
  }
  
  render() {
    return (
      <div className="history-item">
        <hr className="history-item__separator" />
        <div className="history-item__header">
          { this.renderHeader() }
        </div>
        <table className="history-item__details">
          <tbody>
            { this.renderDetails() }
          </tbody>
        </table>
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/history/HistoryItem.js